export const CUSTOMER_SUPPORT_PHONE_DISPLAY = "(623) 263-3386";
export const CUSTOMER_SUPPORT_PHONE_DIAL = "+16232633386";
export const CUSTOMER_SUPPORT_PHONE_TEL = `tel:${CUSTOMER_SUPPORT_PHONE_DIAL}`;

export const CHECKIN_PHONE_DISPLAY = CUSTOMER_SUPPORT_PHONE_DISPLAY;
export const CHECKIN_PHONE_DIAL = CUSTOMER_SUPPORT_PHONE_DIAL;
export const CHECKIN_PHONE_TEL = CUSTOMER_SUPPORT_PHONE_TEL;

export const PHOENIX_YARD_ADDRESS = "1634 N 19th Ave, Phoenix, AZ 85009";
export const PHOENIX_YARD_ENTRANCE_COORDINATES = "33.467333,-112.101250";
export const PHOENIX_YARD_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  PHOENIX_YARD_ENTRANCE_COORDINATES
)}`;
